import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Subject } from 'rxjs';
import { IUser } from '../models/user';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  constructor(private cookieService: CookieService, private router: Router) {}

  UserSubject = new Subject<void>();
  registerSubject = new Subject<any>();

  myUser: IUser = {} as IUser;
  myAuction: any = null;

  config: any = {};

  list_month = [
    { name: 'Janeiro', date: 1 },
    { name: 'Fevereiro', date: 2 },
    { name: 'Março', date: 3 },
    { name: 'Abril', date: 4 },
    { name: 'Maio', date: 5 },
    { name: 'Junho', date: 6 },
    { name: 'Julho', date: 7 },
    { name: 'Agosto', date: 8 },
    { name: 'Setembro', date: 9 },
    { name: 'Outubro', date: 10 },
    { name: 'Novembro', date: 11 },
    { name: 'Dezembro', date: 12 },
  ];

  get myself() {
    return this.myUser;
  }

  set myself(user: IUser) {
    this.myUser = user;
  }

  get myauction() {
    return this.myAuction;
  }

  set myauction(auction: any) {
    this.myAuction = auction;
  }

  watchUser() {
    return this.UserSubject.asObservable();
  }

  unwatchUser() {
    this.UserSubject.unsubscribe();
  }

  changeUser(): void {
    this.UserSubject.next();
  }

  watchRegister() {
    return this.registerSubject.asObservable();
  }

  changeRegister(screen: any): void {
    this.registerSubject.next(screen);
  }

  get token() {
    if (this.cookies) {
      return this.cookieService.get('token');
    } else {
      return sessionStorage.getItem('token');
    }
  }

  /**
   * Função para setar o token no cookie
   * @param token Token que vem da API
   * @param keep Se true, o cookie expira em 60 dias, se false, o cookie expira quando o browser é fechado
   * @return void
   *
   * @author Kauã Landi
   */
  setToken(token: string, keep = false): void {
    if (this.cookies) {
      this.cookieService.set(
        'token',
        token,
        keep ? 60 : undefined,
        '/',
        undefined,
        this.ssl,
        'Strict'
      );
    } else {
      sessionStorage.setItem('token', token);
    }
  }

  get cookies() {
    return localStorage.getItem('cookies') === 'true';
  }

  set cookies(value: boolean) {
    localStorage.setItem('cookies', value.toString());
  }

  logout() {
    this.setToken('', false);
    this.router.navigate(['/login']);
  }

  get ssl() {
    return location.protocol === 'https:';
  }

  scrollPosition(){
    const scrollPosition = JSON.parse(localStorage.getItem('scrollPosition') || '');
    console.log(scrollPosition);

    if (scrollPosition) {
      window.scrollTo(scrollPosition.x, scrollPosition.y);
      localStorage.removeItem('scrollPosition'); // Limpar depois de restaurar
    }
  }
}
